import React, { useState } from "react";
import { Link } from "react-router-dom";
import type { Assessment } from "../models/assessment.ts";

const initialAssessments: Assessment[] = [
    {
        companyName: "AOS",
        assessmentName: "Baseline SIRI Assessment",
        assessor: "Chris Piggott",
    },
    {
        companyName: "Example Plastics",
        assessmentName: "Follow-up Digital Readiness",
        assessor: "Gerald Hurley",
    },
];

export default function AssessmentsList() {
    const [assessments] = useState<Assessment[]>(initialAssessments);

    return (
        <div>
            <h1>Assessments</h1>

            <div style={{ marginBottom: "1rem" }}>
                <Link to="/assessments/new">➕ Add new assessment</Link>
            </div>

            {assessments.length === 0 ? (
                <p>No assessments yet.</p>
            ) : (
                <table
                    style={{
                        borderCollapse: "collapse",
                        width: "100%",
                        maxWidth: "900px",
                    }}
                >
                    <thead>
                    <tr>
                        <th style={{ textAlign: "left", padding: "0.5rem" }}>
                            Company
                        </th>
                        <th style={{ textAlign: "left", padding: "0.5rem" }}>
                            Assessment
                        </th>
                        <th style={{ textAlign: "left", padding: "0.5rem" }}>
                            Assessor
                        </th>
                        <th colSpan={2} style={{ textAlign: "left", padding: "0.5rem" }}>
                            Actions
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    {assessments.map((a, index) => (
                        <tr key={index}>
                            <td style={{ padding: "0.5rem" }}>{a.companyName}</td>
                            <td style={{ padding: "0.5rem" }}>{a.assessmentName}</td>
                            <td style={{ padding: "0.5rem" }}>{a.assessor}</td>
                            <td style={{ padding: "0.5rem" }}>
                                {/* Using index as a stand-in "id" for now */}
                                <Link to={`/assessments/${index}/edit`}
                                      style={{
                                          fontSize: "1rem",
                                          textDecoration: "none",
                                          display: "inline-flex",
                                          alignItems: "center",
                                          gap: "0.25rem",
                                      }}>✏️ Edit</Link>
                            </td>
                            <td style={{ padding: "0.5rem" }}>
                            <Link to={`/assessments/${index}/interview`}
                                      style={{
                                              fontSize: "1rem",
                                              textDecoration: "none",
                                              display: "inline-flex",
                                              alignItems: "center",
                                              gap: "0.25rem",
                                          }}
                                >▶️Start</Link>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            )}
        </div>
    );
}

